import { render } from "./estimate1.vue?vue&type=template&id=5be2739d&scoped=true"
import script from "./estimate1.vue?vue&type=script&lang=js"
export * from "./estimate1.vue?vue&type=script&lang=js"

import "./estimate1.vue?vue&type=style&index=0&id=5be2739d&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be2739d"]])

export default __exports__